import { render, staticRenderFns } from "./chateau-coutet.vue?vue&type=template&id=f9161d4a&scoped=true"
import script from "./chateau-coutet.vue?vue&type=script&lang=js"
export * from "./chateau-coutet.vue?vue&type=script&lang=js"
import style0 from "./chateau-coutet.vue?vue&type=style&index=0&id=f9161d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9161d4a",
  null
  
)

export default component.exports